import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {
  Avatar,
  Box,
  Divider,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { searchUsuEntidadesAction } from '../../../usuario/usu_entidades/UsuEntidadesAction';
import { saveJugadoresAction } from '../JugadoresAction';

const FormJugadores = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const equiposStore = Redux.useSelector((state) => state.equipos);
  const jugadoresStore = Redux.useSelector((state) => state.jugadores);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const activo = jugadoresStore.activo;

  const [jugadoresSelect, setJugadoresSelect] = React.useState([]);

  const [search, setSearch] = React.useState(null);

  const [dni, setDni] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const [loadingSave, setLoadingSave] = React.useState(false);

  const _handleSubmit = async () => {
    if (jugadoresSelect.length > 0) {
      let jugadores = [];
      jugadoresSelect.forEach((el) => {
        jugadores.push(el.usuario.id);
      });

      setLoadingSave(true);
      let res = await saveJugadoresAction(
        { dispatch, notify },
        null,
        {
          idEquipo: equiposStore.activo.id,
          jugadores,
        },
        jugadoresStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  const searchField = (
    <Grid item xs={12} md={12}>
      <LoadingWidget isLoading={loading} />
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
        <TextField
          sx={{
            minWidth: '300px',
          }}
          size="small"
          id={CONST.dni.name}
          required
          label={CONST.dni.label}
          value={dni}
          onChange={(e) => setDni(e.target.value)}
        />
        <BotonComponent
          click={async () => {
            setLoading(true);
            const res = await searchUsuEntidadesAction(notify, {
              idEntidad: entidadesStore.activo.id,
              q: dni,
            });

            setLoading(false);
            if (res) setSearch(res.data);
          }}
          text="BUSCAR"
          disabled={loading || loadingSave || !dni || dni === ''}
          orange
          saveIcon
        />
      </Stack>
    </Grid>
  );

  const cardJugador = (data) => (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Avatar
        alt={data.perfil.avatar}
        sx={{ width: 50, height: 50 }}
        src={getFilesArchivos(data.perfil.avatar)}
      />
      <Typography variant="body1">
        {data.perfil.tipoDni}-{data.perfil.dni}
        {data.perfil.pnombre} {data.perfil.papellido}
      </Typography>
    </Stack>
  );

  const cardSearch = search && (
    <Grid item xs={12} md={12}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
      >
        {cardJugador(search.usuario)}
        <BotonComponent
          click={() => {
            setDni('');
            setSearch(null);
            setJugadoresSelect((old) => [...old, search]);
          }}
          disabled={loadingSave}
          green
          icon
          colorIcon="white"
          size="medium"
          addIcon
        />
      </Stack>
    </Grid>
  );

  const tablaAsignados = jugadoresSelect.length > 0 && (
    <Grid item md={12}>
      <Divider sx={{ my: 1 }}>Asignados</Divider>
      <TableContainer>
        <Table size="small" aria-label="materias">
          <TableHead>
            <TableRow>
              <TableCell width="10%">Nro.</TableCell>
              <TableCell width="80%">Jugador</TableCell>
              <TableCell>Acción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {jugadoresSelect.map((el, index) => (
              <TableRow
                key={el.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>{index + 1}</TableCell>
                <TableCell>{cardJugador(el.usuario)}</TableCell>
                <TableCell>
                  <Tooltip title="Eliminar" placement="top">
                    <IconButton
                      color="error"
                      size="small"
                      aria-label="Eliminar"
                      onClick={() => {
                        const l = jugadoresSelect.filter(
                          (it) => it.id !== el.id,
                        );
                        setJugadoresSelect(l);
                      }}
                    >
                      <DeleteForeverIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}
        {searchField}
        {cardSearch}
        {tablaAsignados}
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text="GUARDAR"
            disabled={loadingSave}
            green
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormJugadores;
